<template>
  <div class="backes">
    <div class="lbj">
      <div class="backlist">
        <div class="liebiao"><router-link target="" to="/goods/huodong" style="color:white">返回列表页</router-link></div>
      </div>
      <div class="boxxq">
        <div class="boxtitle">
          <div class="biximg">
            <img :src="parmit.eventCoverValue" alt="" style="width:100%;height:100%;">
          </div>
          <div class="boxte">
            <div class="boxte_title">{{parmit.title}}</div>
            <!-- <div class="boxte_book">
              <img src="../../assets/goods/book.png" alt />
              <span>{{parmit.pageView}}次</span>
            </div> -->
            <div class="boxte_time">
              <img src="../../assets/goods/time.png" alt />
              <span style="white-space:nowrap;">{{parmit.startTime}}—{{parmit.endTime}}</span>
            </div>
          </div> 
        </div>
        <div class="kbp"></div>
        <div class="neirong" v-html="parmit.content"></div>
        <div class="kongbai"></div>
        <span class="hddz1">活动地址：</span><span class="span" @click='herf'>{{parmit.outUrl}} </span>
      </div>
    </div>
  </div>
</template>
<script>

import { getCurrentInstance, onMounted,ref} from "vue";
import {  useRoute } from "vue-router"; //引入路由
 
export default {
  setup() {
      const { proxy } = getCurrentInstance();
      const route = useRoute()
      const parmit = ref({})
      const onelist =()=>{
        let obj ={
         activityId: route.query.activityId
        }
         proxy.$get("v3/promotion/front/activity/detail",obj).then(res => {
            parmit.value=res.data
            
            console.log(parmit.value,11111111111111)
      });
    }
    const herf =()=>{
 
        window.open(parmit.value.outUrl)
    }
    onMounted(() => {
        onelist()
    });
    return {
      onelist,
      parmit,
      herf
    };
  }
};
</script>
<style lang="scss" scoped>
.neirong {
  margin-top: 62px;
  color: rgba(16, 16, 16, 100);
  font-size: 28px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  text-indent: 40px;
  
}
.kbp {
  height: 21px;
  border-bottom: 1px solid #bbbbbb;
}
.boxte_time {
  margin-top: 6px;
  position: relative;
  span {
    position: absolute;
    top: 6px;
    left: 30px;
  }
}
.boxte_book {
  margin-top: 47px;
  position: relative;
  span {
    position: absolute;
    top: 6px;
    left: 30px;
  }
}
.boxte_title {
  color: rgba(16, 16, 16, 100);
  font-size: 48px;
  text-align: left;
  font-family: SourceHanSansSC-bold;
  white-space:nowrap;
}
.liebiao {
  width: 135px;
  height: 35px;
  line-height: 35px;
  border-radius: 3px;
  background-color: rgba(255, 0, 0, 100);
  color: rgba(255, 255, 255, 100);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  float: right;
  margin-top: 18px;
  margin-right: 91px;
}
.backlist {
  height: 70px;
  background-color: white;
  margin-top: 12px;
}
.boxte {
  width: 200px;
  margin-left: 45px;
}
.boxtitle {
  display: flex;
}
.backes {
  background-color: #f4f4f4;
  overflow: hidden;
}
.biximg {
  width: 258px;
  height: 186px;
  background-color: #f4f4f4;
}
.lbj {
  width: 1200px;
  
  margin: 0 auto;
}
.boxxq {
  padding: 13px 34px;
  background-color: white;
  margin-top: 41px;
}
.hddz{
  
  font-size: 26px;
}
.hddz1{
  margin-left: 42px;
  font-size: 26px;
}
.kongbai{
  height: 50px;
}
.span{
  font-size: 20px;
}
</style>